// ============================================
// Configurações — registro das seções do hub (#131)
// ============================================
// Fonte única das sub-rotas de /settings: a nav lateral (desktop), a lista
// (celular), o breadcrumb do RaizLayout e a paleta de comandos leem daqui.
// A ordem é a ordem de exibição; a primeira é o destino do índice no desktop.

import type { SvgIconComponent } from '@mui/icons-material'
import WorkspacesRoundedIcon from '@mui/icons-material/WorkspacesRounded'
import MapRoundedIcon from '@mui/icons-material/MapRounded'
import GroupRoundedIcon from '@mui/icons-material/GroupRounded'
import VpnKeyRoundedIcon from '@mui/icons-material/VpnKeyRounded'
import NotificationsActiveRoundedIcon from '@mui/icons-material/NotificationsActiveRounded'

export interface SettingsSection {
  /** Segmento da URL depois de /settings/. */
  slug: string
  label: string
  /** Uma linha, sem verbo: o que mora ali. Aparece na nav e na lista do celular. */
  description: string
  icon: SvgIconComponent
}

export const SETTINGS_BASE = '/settings'

export const SETTINGS_SECTIONS: SettingsSection[] = [
  { slug: 'workspace', label: 'Workspace', description: 'Nome e vertical do workspace', icon: WorkspacesRoundedIcon },
  { slug: 'maps', label: 'Mapas', description: 'Chave do Google Maps da empresa', icon: MapRoundedIcon },
  { slug: 'users', label: 'Usuários', description: 'Contas, papéis e senhas desta empresa', icon: GroupRoundedIcon },
  { slug: 'api-keys', label: 'Chaves de API', description: 'Credenciais de máquina para ERP, BI e parceiros', icon: VpnKeyRoundedIcon },
  { slug: 'alerts', label: 'Canais de alerta', description: 'Webhook e WhatsApp para os eventos do detector', icon: NotificationsActiveRoundedIcon },
]

export const settingsPath = (slug: string): string => `${SETTINGS_BASE}/${slug}`

/** Seção de `/settings/<slug>`; null no índice (`/settings`) ou em slug desconhecido. */
export const settingsSectionForPath = (pathname: string): SettingsSection | null => {
  const m = /^\/settings\/([^/]+)\/?$/.exec(pathname)
  if (m == null) return null
  return SETTINGS_SECTIONS.find((s) => s.slug === m[1]) ?? null
}
